import type { HotelRoomOptionsRequest } from 'tripPlanner/api/types'

export const all = ['offerDetail'] as const
export const detail = (offerId: string, region: string, accommodationPropertyId?: string, offerType?: string, checkIn?: string, checkOut?: string, occupancies?: string, flexibleMonths?: string, flexibleNights?: string, orderId?: string) =>
  [...all, offerId, region, accommodationPropertyId, offerType, checkIn, checkOut, occupancies, flexibleMonths, flexibleNights, orderId] as const
export const reviews = (offerId: string, region: string) =>
  [...all, 'reviews', offerId, region] as const
export const roomOptions = (
  offerId: string,
  region: string,
  checkIn: string | undefined,
  checkOut: string | undefined,
  nights: number | undefined,
  rooms: HotelRoomOptionsRequest['rooms'],
  selections: HotelRoomOptionsRequest['selections'],
) =>
  [...all, 'roomOptions', offerId, region, checkIn, checkOut, nights, rooms, selections] as const
